module.exports = {"420204070":"团城山街道","420204400":"社区事务管理委员会","420204401":"长乐山工业园管理委员会","420204402":"东方山风景区服务处","420204403":"下陆区生态新区管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420204.json
// module id = 1713
// module chunks = 0